<info-modal [title]="title" (onOk)="ok()">
	<loading [isLoad]="detailLoader || !details"></loading>

	<table class="table">
		<thead>
			<tr>
				<th>{{ 'adminstat.template.template name' | translate }}</th>
				<th>{{ 'adminstat.template.human template name' | translate }}</th>
				<th>{{ 'adminstat.template.find count' | translate }}</th>
			</tr>
		</thead>
		
		<tbody>
			<tr *ngFor="let stat of details">
				<td>
					{{ stat.templateName }}
				</td>
	
				<td>
					{{ 'templatenames.' + stat.templateName | translate }}
				</td>
	
				<td>
					{{ stat.count }}
				</td>
			</tr>
		</tbody>
	</table>

</info-modal>
